import axios from 'axios';

export default {
  init(app) {
    axios.defaults.headers.common.Accept = 'application/json';
    axios.defaults.headers.common['Content-Type'] = 'application/json';

    axios.interceptors.request.use((config) => {
      return config;
    });
    axios.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        console.error('error', error);
        // expired token or unauthenticated
        if (error.response.status === 401 && app.$router.currentRoute.name !== 'Login') { // Unauthorized
          app.$notify({
            title: 'Unauthenticated',
            text: 'You are not authenticated to complete this action.',
            type: 'error',
            width: 350,
          });
        } else if (error.response.status === 403) { // Unauthenticated
          app.$notify({
            title: 'Unauthorized',
            text: 'You are not authorized to complete this action.',
            type: 'error',
            width: 350,
          });
        } else if (error.response.status === 429) { // Rate Limited
          app.$notify({
            title: 'Too Many Requests',
            text: 'Please wait 5 or more seconds, and then try again.',
            type: 'error',
            width: 350,
          });
        } else if (error.response.status === 500 && Object.prototype.hasOwnProperty.call(error.response, 'data')) { // Internal Server Error
          console.error(error.response.data.error, error.response.data);
        }
        return Promise.reject(error);
      },
    );

  },
};
